import { createGlobalStyle } from 'styled-components';

import SourceSansProBold from '@/assets/fonts/source-sans-pro-bold.woff';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'SourceSansProBold';
    src: url(${SourceSansProBold});
    font-weight: bold;
    font-style: normal;
  }

  .generated-images-holder-var19 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1080px;
  }

  .image-holder-var19 {
    width: 100%;
    display: flex;
    position: relative;
    height: 1350px;
    flex-wrap: wrap;
    gap: 12px;
  }

  .image-var19 {
    position: relative;
    width: calc(50% - 6px);
    display: block;
    height: 669px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .full-image-var19 {
    position: relative;
    width: 100%;
    display: block;
    height: 669px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .bottom-text-var19 {
    position: absolute;
    z-index: 2;
    width: 100%;
    bottom: 60px;
    top: 0;
    padding: 0 10px;
    font-size: 62px;
    line-height: 1.28;
    font-family: SourceSansProBold;
    letter-spacing: 1.3px;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      background-color: #1f1e1e;
      display: inline-block;
      margin: 0;
      padding: 25px 47px 26px;
    }
    p.custom-brakes-var19 {
      white-space: nowrap;
    }
  }

  .watermark-var19 {
    position: absolute;
    top: 38px;
    left: 43px;
  }
  .left-actual-photo-var19 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .left-actual-photo-var19--top {
    top: 0;
    bottom: auto;
  }
  .right-actual-photo-var19 {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 72px;
  }
  .right-actual-photo-var19--top {
    top: 0;
    bottom: auto;
  }
  .bottom-actual-photo-var19 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .bottom-actual-photo-var19--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
